const PILLS_CATEGORIES_FETCH = 'bfb/pills-category/PILLS_CATEGORIES_FETCH';
const PILLS_CATEGORIES_FETCH_SUCCEEDED = 'bfb/pills-category/PILLS_CATEGORIES_FETCH_SUCCEEDED';
const PILLS_CATEGORIES_FETCH_FAILED = 'bfb/pills-category/PILLS_CATEGORIES_FETCH_FAILED';

export default {
  PILLS_CATEGORIES_FETCH,
  PILLS_CATEGORIES_FETCH_SUCCEEDED,
  PILLS_CATEGORIES_FETCH_FAILED,
};
